"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- TIP : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'Tip',
  group: _definitionhelpers.groupNames.messages,
  props: {
    space: {
      type: 'string',
      default: 'left',
      options: ['left', 'right', 'around']
    },
    icon: {
      type: 'string',
      default: 'question-circle',
      help: {
        title: 'fontawesome library',
        desc: 'We use this external library of font icons throughout our products. Copy and paste an icon name in this field to see it appear.',
        link: {
          text: 'Visit Library >',
          url: 'https://fontawesome.com/icons?d=gallery&m=free'
        }
      }
    },
    content: {
      type: 'object',
      default: _react.default.createElement("p", null, "This is a tip")
    }
  }
};
exports.default = _default;